import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { ListarEvidenciasPorIncidencia, urlBase } from '../../../services/api';
import { useAuth } from '../../../context/AuthContext';
import { Cargando } from '../../Cargando';

const buildEvidenceUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(urlBase).replace(/\/+$/, '');
  const cleanPath = String(path).replace(/^\/+/, '');
  return `${base}/${cleanPath}`;
};

export default function EvidenciasPorIncidencias({ incidencia, show, onClose }) {
  const { token } = useAuth();
  const [evidencias, setEvidencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const incidenciaId = incidencia?.id ?? incidencia;
  const descripcion = incidencia?.description ?? '';

  useEffect(() => {
    let ignore = false;

    const leerServicioEvidencia = async () => {
      if (!show || !incidenciaId) {
        setEvidencias([]);
        setError('');
        return;
      }

      try {
        setLoading(true);
        setError('');
        const dataEvidencia = await ListarEvidenciasPorIncidencia({ incidenciaId, token });
        console.log("EVIDENCIASS")
        console.log(dataEvidencia)
        if (ignore) return;
        const items = Array.isArray(dataEvidencia)
          ? dataEvidencia
          : Array.isArray(dataEvidencia?.value)
            ? dataEvidencia.value
            : [];
        setEvidencias(items);
      } catch (err) {
        console.error(err);
        if (!ignore) setError('No se pudieron cargar las evidencias.');
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    leerServicioEvidencia();

    return () => {
      ignore = true;
    };
  }, [show, incidenciaId, token]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title mb-0">Evidencias</h5>
                {descripcion && <small className="text-muted">{descripcion}</small>}
              </div>
              <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {loading && <div className="text-center text-muted"><Cargando /></div>}
              {error && !loading && <div className="alert alert-danger text-center py-2 mb-0">{error}</div>}

              {!loading && !error && evidencias.length > 0 && (
                <Carousel showThumbs={true} infiniteLoop useKeyboardArrows dynamicHeight>
                  {evidencias.map((item, index) => {
                    const src = buildEvidenceUrl(item.url);
                    return (
                      <div key={index} className="text-center">
                        <img
                          src={`https://intranet.grupopolo.pe/gp-vigilancia-Api${item.url}`}
                          alt={`Evidencia ${index + 1}`}
                          className="img-fluid"
                          style={{ maxHeight: '60vh', objectFit: 'contain', margin: '0 auto' }}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              )}

              {!loading && !error && evidencias.length === 0 && (
                <div className="text-center text-muted">No hay evidencias</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
